import { createContext, useContext, useEffect, useState } from "react";

const UserContext = createContext({
  user: null,
  signIn: () => {},
  signOut: () => {},
});

export const useUserContext = () => useContext(UserContext);

export const UserContextProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // 🔥 This effect hydrates user from localStorage on app reload
  useEffect(() => {
    const token = localStorage.getItem("token");
    const refreshToken = localStorage.getItem("refreshToken");
    const expiresAt = localStorage.getItem("accessTokenExpiresAt");
    const userInfo = localStorage.getItem("userInfo");

    let parsedUserInfo;
    try {
      parsedUserInfo = userInfo ? JSON.parse(userInfo) : null;
    } catch (e) {
      parsedUserInfo = null;
    }

    // If we have a token, refreshToken, and expiresAt, set the user context
    if (token && refreshToken && expiresAt) {
      setUser({
        info: parsedUserInfo,
        token: token,
        refreshToken: refreshToken,
      });
    }
  }, []);

  const signIn = (data) => {
    const expiresAt = Date.now() + 15 * 60 * 1000; // 15 minutes
    localStorage.setItem("accessTokenExpiresAt", expiresAt);
    localStorage.setItem("token", data?.token);
    localStorage.setItem("refreshToken", data?.refreshToken);
    localStorage.setItem("userInfo", JSON.stringify(data?.user));

    setUser({
      info: data?.user,
      token: data?.token,
      refreshToken: data?.refreshToken,
    });
  };

  const signOut = () => {
    localStorage.clear(); // clears token, refreshToken, expiresAt
    setUser(null);
  };

  const values = {
    user,
    setUser,
    signIn,
    signOut,
  };

  return <UserContext.Provider value={values}>{children}</UserContext.Provider>;
};
